import React from 'react';
export function ProofSection() {
  const testimonials = [{
    initial: 'S',
    name: 'Sarah',
    location: 'Brisbane',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=96&h=96&fit=crop&crop=face',
    quote: '"I measured our bedroom before and after. With stickers on the router and kids\' tablets, readings dropped from 250 to 85 mV/m. Within two weeks, my son slept through the night for the first time in three years."'
  }, {
    initial: 'M',
    name: 'Marcus',
    location: 'Sydney',
    avatar: 'https://cdn.magicpatterns.com/uploads/jm3cxQRvN1TwWumqraSD3Z/Untitled_design_(2).png',
    quote: "\"I'm a skeptic. I bought a meter before I'd even order. Applied the stickers, measured immediately. The reduction was exactly as advertised. My morning brain fog is gone. I'm more focused at work.\""
  }, {
    initial: 'R',
    name: 'Rebecca',
    location: 'Perth',
    avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=96&h=96&fit=crop&crop=face',
    quote: '"My daughter was on her phone until midnight every night. Sleep-deprived, anxious, terrible grades. I put QShield stickers on her devices—she didn\'t even notice. Her sleep improved within a week. I\'m convinced."'
  }];
  const testingSteps = ['Rent an EMF meter online (~$30–50) or borrow from a friend', 'Take baseline reading: Hold phone in hand, note the meter', 'Apply QShield sticker, wait 24 hours for cure', 'Take the same reading again', 'Compare'];
  return <section id="testimonials" className="w-full bg-white py-8 md:py-12 lg:py-16 px-4 md:px-6 border-t-[3px]" style={{
    borderColor: '#2D9B6E',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
  }} data-id="element-117">
      <div className="max-w-5xl mx-auto" data-id="element-118">
        <h2 className="text-[29px] md:text-[34px] lg:text-[43px] font-bold mb-8" style={{
        color: '#2D9B6E'
      }} data-id="element-119">
          THE PROOF (You Can Verify It Yourself)
        </h2>

        <div className="mb-8 -mx-4 md:-mx-6" data-id="element-120">
          <img src="https://cdn.magicpatterns.com/uploads/oLoTcA6a14RxNDZfLWBxJz/unnamed_(4).jpg" alt="Sarah M. from Brisbane testimonial - tested daughter's iPad EMF before and after QShield sticker, 87% reduction" className="w-full rounded-lg shadow-lg" style={{
          boxShadow: '0px 8px 24px rgba(27, 79, 158, 0.12)'
        }} data-id="element-121" />
        </div>

        <p className="text-base md:text-lg font-semibold mb-4" style={{
        color: '#1B4F9E'
      }} data-id="element-122">
          QShield stickers have been independently tested by Cruz Medicinals
          Australia in 2024. Results: "QShield stickers reduced measured EMF
          radiation by an average of 68% (range 45–85% depending on device
          type)."
        </p>

        {/* Credentials Badge */}
        <div className="inline-block px-4 py-3 rounded text-sm font-semibold border" style={{
        backgroundColor: '#F0FFF7',
        borderColor: '#2D9B6E',
        color: '#2D9B6E'
      }} data-id="element-123">
          ✓ Independent Third-Party Testing
        </div>

        {/* EMF Meter Image */}
        <div className="my-10" data-id="element-124"></div>

        {/* Test Results Statement */}
        <div className="p-4 md:p-5 rounded-r border-l-4 my-6" style={{
        backgroundColor: '#F0F7FF',
        borderColor: '#2D9B6E'
      }} data-id="element-125">
          <p className="text-base font-semibold" style={{
          color: '#2D9B6E'
        }} data-id="element-126">
            This is measured. This is verifiable. You can test it yourself.
          </p>
        </div>

        {/* Self-Testing Instructions */}
        <div className="p-6 md:p-8 rounded-lg mt-8" style={{
        backgroundColor: '#F8F9FA'
      }} data-id="element-127">
          <h4 className="text-lg font-semibold mb-4" style={{
          color: '#1B4F9E'
        }} data-id="element-128">
            How:
          </h4>
          <ol className="space-y-3" data-id="element-129">
            {testingSteps.map((step, index) => <li key={index} className="flex items-start gap-3 text-base" style={{
            color: '#2C3E50'
          }} data-id="element-130">
                <span className="flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center text-sm font-bold text-white" style={{
              backgroundColor: '#1B4F9E'
            }} data-id="element-131">
                  {index + 1}
                </span>
                <span data-id="element-132">{step}</span>
              </li>)}
          </ol>

          {/* Expected Result */}
          <div className="mt-4 p-4 rounded border-l-4" style={{
          backgroundColor: '#F0FFF7',
          borderColor: '#2D9B6E'
        }} data-id="element-133">
            <p className="text-base font-semibold" style={{
            color: '#2D9B6E'
          }} data-id="element-134">
              Expected result: 40–80% reduction. Visible immediately.
              Repeatable.
            </p>
          </div>
        </div>

        {/* EMF Meter Testing Image */}
        <div className="mt-6 -mx-4 md:-mx-6" data-id="element-135">
          <img src="https://cdn.magicpatterns.com/uploads/c8gbZgB5kDicMjAEFHaKcF/unnamed_(8).jpg" alt="GQ 390 EMF meter reading 68 mV/m after QShield sticker applied to phone" className="w-full rounded-lg shadow-md" data-id="element-136" />
        </div>

        {/* Testimonials Section */}
        <div className="mt-12" data-id="element-137">
          <h3 className="text-[24px] md:text-[29px] font-semibold mb-6" style={{
          color: '#1B4F9E'
        }} data-id="element-138">
            Real Australian Testimonials
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-139">
            {testimonials.map((testimonial, index) => <div key={index} className="testimonial-card p-5 md:p-6 rounded-lg border" style={{
            backgroundColor: '#F0F7FF',
            borderColor: '#1B4F9E',
            boxShadow: '0px 4px 12px rgba(27, 79, 158, 0.08)'
          }} data-id="element-140">
                <div className="flex items-center gap-3 mb-4" data-id="element-141">
                  <img src={testimonial.avatar} alt={testimonial.name} className="w-12 h-12 rounded-full object-cover" data-id="element-142" />
                  <div data-id="element-143">
                    <div className="text-sm font-semibold" style={{
                  color: '#2C3E50'
                }} data-id="element-144">
                      {testimonial.name}
                    </div>
                    <div className="text-xs text-gray-500" data-id="element-145">
                      {testimonial.location}
                    </div>
                  </div>
                </div>
                <p className="text-base font-medium italic" style={{
              color: '#1B4F9E',
              lineHeight: '1.6'
            }} data-id="element-146">
                  {testimonial.quote}
                </p>
                <div className="mt-3 text-yellow-500" data-id="element-147">★★★★★</div>
              </div>)}
          </div>

          {/* 90-Day Money-Back Guarantee Image */}
          <div className="mt-10 -mx-4 md:-mx-6" data-id="element-148">
            <img src="https://cdn.magicpatterns.com/uploads/5DXWFitcy8mNreRK9iwjgy/unnamed_(9).jpg" alt="90-Day Money-Back Guarantee - If your EMF meter doesn't show measurable reduction, we refund 100%. No questions asked." className="w-full rounded-lg shadow-md" data-id="element-149" />
          </div>
        </div>
      </div>
    </section>;
}